var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('van-loading',{staticStyle:{"text-align":"center"},attrs:{"size":"24px"}},[_vm._v(" 加载中... ")]):_c('van-divider',{style:({ color: '#999999', borderColor: '#979797' })},[_vm._v(" 我是有底线的哦 ")])}
var staticRenderFns = []

export { render, staticRenderFns }